import { createSelector } from "@ngrx/store";
import { AppRootState } from "..";
import {TawAppState} from '../app-state/app.state'

export class TawAppStateSelector {
  public static selectFeature = (rootState: AppRootState) => rootState.appState;
  public static selectMessage = createSelector(TawAppStateSelector.selectFeature, (s:TawAppState) => s.message);
}
